import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import ReservationAPI from '../../../../API/ReservationAPI';
import ReservationsHistoricalTableHeader from './ReservationsHistoricalTableHeader';
import ReservationsToolbar from '../../ReservationsToolbar';
import LinearProgress from '../../../Utils/LinearProgress';
import { FormatDate } from '../../../Utils/GenericFunctions';
import { NO_TABLE_DATA_MESSAGE, STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_ASCENDING, ORDER_BY_RESERVATION_DATE, RESERVATION_TABLE_RELOAD_TIMER } from '../../../../Utils/Constants';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { handleServerError } from '../../../../Utils/Helper';


const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: '#F6F6F6'
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  textCenter: {
    textAlign: 'center'
  },
  tblRow: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
    },
    height: '30px'
  },
  cellPadding: {
    paddingLeft: '6px',
    '&:last-child': {
      paddingLeft: '6px'
    }
  },
  tblFooter: {
    height: '30px',
    minHeight: '30px'
  },
  pageButton: {
    width: '30px',
    height: '30px',
    margin: '0px 8px'
  }
});


export class ReservationsHistoricalTable extends Component {
  _isMounted;
  searchTimer = null;
  tableDataAPI

  constructor(props) {
    super(props);
    this.state = {
      order: ORDER_ASCENDING,
      orderBy: ORDER_BY_RESERVATION_DATE,
      data: [],
      page: STARTING_TABLE_PAGE,
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      count: 0,
      search: '',
      reloading: false,
      openError: false,
      alertMessage: ''
    };
    this.tableDataAPI = new ReservationAPI();
  }

  componentDidMount() {
    this._isMounted = true;
    this.reloadTable();
    this.interval = setInterval(() => {
      this.reloadTable();
    }, RESERVATION_TABLE_RELOAD_TIMER);
  };

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.interval);
  };

  componentWillReceiveProps() {
    this.reloadTable();
  };

  reloadTable() {
    this.setState({ reloading: true });
    this.tableDataAPI.getHistoricalReservations(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ListReservedCars,
          count: response.data.NumberFilteredResults,
          page: STARTING_TABLE_PAGE,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ reloading: true });
    this.tableDataAPI.getHistoricalReservations(this.state.page, this.state.rowsPerPage, orderBy, order, this.state.search).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ListReservedCars,
          count: response.data.NumberFilteredResults,
          order, orderBy,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ reloading: true });
    this.tableDataAPI.getHistoricalReservations(page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ListReservedCars,
          count: response.data.NumberFilteredResults,
          page: page,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ reloading: true });
    this.tableDataAPI.getHistoricalReservations(this.state.page, event.target.value, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ListReservedCars,
          count: response.data.NumberFilteredResults,
          rowsPerPage: event.target.value,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  reloadTableBySearch(searchBy) {
    this.setState({ reloading: true });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.tableDataAPI.getHistoricalReservations(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, searchBy).then((response) => {
        if (this._isMounted)
          this.setState({
            data: response.data.ListReservedCars,
            count: response.data.NumberFilteredResults,
            search: searchBy,
            page: STARTING_TABLE_PAGE,
            reloading: false
          });
      }).catch((error) => {
        if (this._isMounted)
          this.setState({
            reloading: false,
            openError: true,
            alertMessage: handleServerError(error)
          })
      });
    }, 1500);
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  renderTableRecords(cReservationList) {
    const { classes } = this.props;

    const cReservations = cReservationList.map(rItem => {
      return (
        <TableRow key={rItem.reservationId} tabIndex={-1} className={classes.tblRow}>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {rItem.reservedCarBrandDesc}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {rItem.reservedCarModelDesc}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {rItem.reservedCarAnnouncedOptionalsDescription}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {rItem.reservedCarColorDesc}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {FormatDate(rItem.reservedCarDate)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {rItem.reservedCarClient}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {rItem.reservedCarHolderName}
          </TableCell>
        </TableRow>
      );
    })
    return cReservations;
  }

  renderNoRecordMessages() {
    return NO_TABLE_DATA_MESSAGE;
  }


  render() {
    const { classes } = this.props;
    const { data, order, orderBy, rowsPerPage, page, count, reloading } = this.state;

    return (
      <Paper className={classes.root}>

        <ReservationsToolbar
          reloadTableBySearch={this.reloadTableBySearch.bind(this)}
          reloadTable={this.reloadTable.bind(this)}
          tableTitle={'HISTÓRICO RESERVAS'}
          withSCSearch={false}
        />
        <div className={classes.tableWrapper}>
          <Table>
            <TableHead className={classes.tblHead} >
              <ReservationsHistoricalTableHeader
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
              />
            </TableHead>
            <TableBody>
              {this.renderTableRecords(data)}
            </TableBody>
          </Table>
          {(!data.length) ? this.renderNoRecordMessages() : null}
        </div>
        {reloading && <LinearProgress />}
        <TablePagination
          component='div'
          count={count}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          labelRowsPerPage={'Resultados por página:'}
          page={page}
          backIconButtonProps={{ className: classes.pageButton }}
          nextIconButtonProps={{ className: classes.pageButton }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => `A mostrar resultados ${from}-${to} de ${count}`}
          classes={{ toolbar: classes.tblFooter }}
        />

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    );
  }
}

ReservationsHistoricalTable.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTableBySearch: PropTypes.func,
  reloadTable: PropTypes.func
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(ReservationsHistoricalTable));


// WEBPACK FOOTER //
// ./src/components/Reservations/Personal/Historical/ReservationsHistoricalTable.js